// @flow

import {defineMessages} from 'react-intl';

export const countryNameMessages = defineMessages({
  AU: {
    id: 'docsShell.Terminal.countryNames.AU',
    description: 'Country label. Australia',
    defaultMessage: 'Australia',
  },
  CA: {
    id: 'docsShell.Terminal.countryNames.CA',
    description: 'Country label. Canada',
    defaultMessage: 'Canada',
  },
  DE: {
    id: 'docsShell.Terminal.countryNames.DE',
    description: 'Country label. Germany',
    defaultMessage: 'Germany',
  },
  IE: {
    id: 'docsShell.Terminal.countryNames.IE',
    description: 'Country label. Ireland',
    defaultMessage: 'Ireland',
  },
  FR: {
    id: 'docsShell.Terminal.countryNames.FR',
    description: 'Country label. France',
    defaultMessage: 'France',
  },
  GB: {
    id: 'docsShell.Terminal.countryNames.GB',
    description: 'Country label. United Kingdom',
    defaultMessage: 'United Kingdom',
  },
  NL: {
    id: 'docsShell.Terminal.countryNames.NL',
    description: 'Country label. Netherlands',
    defaultMessage: 'Netherlands',
  },
  NZ: {
    id: 'docsShell.Terminal.countryNames.NZ',
    description: 'Country label. New Zealand',
    defaultMessage: 'New Zealand',
  },
  SG: {
    id: 'docsShell.Terminal.countryNames.SG',
    description: 'Country label. Singapore',
    defaultMessage: 'Singapore',
  },
  US: {
    id: 'docsShell.Terminal.countryNames.US',
    description: 'Country label. United States',
    defaultMessage: 'United States',
  },
  BE: {
    id: 'docsShell.Terminal.countryNames.BE',
    description: 'Country label. Belgium',
    defaultMessage: 'Belgium',
  },
  AT: {
    id: 'docsShell.Terminal.countryNames.AT',
    description: 'Country label. Austria',
    defaultMessage: 'Austria',
  },
  ES: {
    id: 'docsShell.Terminal.countryNames.ES',
    description: 'Country label. Spain',
    defaultMessage: 'Spain',
  },
  DK: {
    id: 'docsShell.Terminal.countryNames.DK',
    description: 'Country label. Denmark',
    defaultMessage: 'Denmark',
  },
  IT: {
    id: 'docsShell.Terminal.countryNames.IT',
    description: 'Country label. Italy',
    defaultMessage: 'Itay',
  },
  SE: {
    id: 'docsShell.Terminal.countryNames.SE',
    description: 'Country label. Sweden',
    defaultMessage: 'Sweden',
  },
  LU: {
    id: 'docsShell.Terminal.countryNames.LU',
    description: 'Country label. Luxembourg',
    defaultMessage: 'Luxembourg',
  },
  PT: {
    id: 'docsShell.Terminal.countryNames.PT',
    description: 'Country label. Portugal',
    defaultMessage: 'Portugal',
  },
  NO: {
    id: 'docsShell.Terminal.countryNames.NO',
    description: 'Country label. Norway',
    defaultMessage: 'Norway',
  },
  FI: {
    id: 'docsShell.Terminal.countryNames.FI',
    description: 'Country label. Finland',
    defaultMessage: 'Finland',
  },
  CH: {
    id: 'docsShell.Terminal.countryNames.CH',
    description: 'Country label. Switzerland',
    defaultMessage: 'Switzerland',
  },
});

export const countryNames = {
  AU: 'Australia',
  CA: 'Canada',
  DE: 'Germany',
  IE: 'Ireland',
  FR: 'France',
  GB: 'United Kingdom',
  NL: 'Netherlands',
  NZ: 'New Zealand',
  SG: 'Singapore',
  US: 'United States',
  BE: 'Belgium',
  AT: 'Austria',
  ES: 'Spain',
  DK: 'Denmark',
  IT: 'Italy',
  SE: 'Sweden',
  LU: 'Luxembourg',
  PT: 'Portugal',
  NO: 'Norway',
  FI: 'Finland',
  CH: 'Switzerland',
};

/**
 * A sort()-friendly function that orders countries by name, given two country codes as input
 * @param {string} countryCodeA - First country code.
 * @param {*} countryCodeB - Second country code.
 * @returns A number signfying sort order
 */
export const countrySorter = (countryCodeA: string, countryCodeB: string) =>
  countryNames[countryCodeA].localeCompare(countryNames[countryCodeB]);
